import React from "react";
import nccaLogo from "../assets/img/BottomLogos/B1.jpeg";
import sapbLogo from "../assets/img/BottomLogos/B2.jpeg";
import agricultureLogo from "../assets/img/BottomLogos/B3.jpeg";
import sapcaLogo from "../assets/img/BottomLogos/BL2.jpeg";
import outsuranceLogo from "../assets/img/BottomLogos/BL4.jpeg";

type Recognition = {
  image: string;
  alt: string;
  title: string;
};

const recognitions: Recognition[] = [
  {
    image: agricultureLogo,
    alt: "Agriculture, Land Reform and Rural Development logo",
    title: "Agriculture & Rural Development",
  },
  {
    image: nccaLogo,
    alt: "National Contract Cleaners Association logo",
    title: "NCCA",
  },
  {
    image: sapbLogo,
    alt: "South African Pest Control Board logo",
    title: "SAPB",
  },
  {
    image: sapcaLogo,
    alt: "South African Pest Control Association member logo",
    title: "SAPCA Member",
  },
  {
    image: outsuranceLogo,
    alt: "OUTsurance logo",
    title: "Protected Service Partner",
  },
];

export const RecognitionSection: React.FC = () => {
  return (
    <section className="py-xl bg-white relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-16 right-0 h-48 w-48 rounded-full bg-secondary/10 blur-3xl" />
        <div className="absolute -bottom-20 left-0 h-56 w-56 rounded-full bg-primary/10 blur-3xl" />
      </div>

      <div className="max-w-container-max mx-auto px-md relative z-10">
        <div className="rounded-[2rem] bg-white overflow-hidden">
          <div className="bg-brand-gradient px-lg py-md text-center text-white">
            <p className="text-xs font-bold uppercase tracking-[0.35em] text-white/80 mb-2">
              Trusted credentials
            </p>
            <h2 className="font-headline-lg text-headline-lg">
              Recognition that backs our service quality
            </h2>
          </div>

          <div className="px-md py-lg md:px-lg md:py-xl">
            <div className="grid gap-lg lg:grid-cols-[1.1fr_0.9fr] items-center">
              <div className="space-y-md">
                <div className="inline-flex items-center gap-sm rounded-full bg-secondary-container px-md py-2 text-secondary font-semibold text-sm">
                  <span className="material-symbols-outlined text-[18px]">
                    verified
                  </span>
                  Professional standards and trusted partnerships
                </div>
                <div>
                  <h3 className="font-headline-md text-headline-md text-primary mb-sm">
                    Built for homes, offices, and specialist cleaning needs
                  </h3>
                  <p className="font-body-md text-on-surface-variant max-w-xl">
                    Our affiliations and recognitions reflect the standards we
                    keep across cleaning, pest control, hygiene, and sanitation
                    services.
                  </p>
                </div>
              </div>

              <div className="space-y-md">
                <div className="flex justify-center">
                  <div className="bg-white p-md flex flex-col items-center justify-center text-center min-h-[170px] w-full max-w-xs">
                    <div className="w-full flex items-center justify-center mb-sm">
                      <img
                        src={recognitions[0].image}
                        alt={recognitions[0].alt}
                        className="max-h-24 w-full object-contain"
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <span className="text-xs font-bold uppercase tracking-[0.22em] text-on-surface-variant">
                      {recognitions[0].title}
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-md">
                  {recognitions.slice(1).map((recognition) => (
                    <div
                      key={recognition.title}
                      className="bg-white p-md flex flex-col items-center justify-center text-center min-h-[170px]"
                    >
                      <div className="w-full flex items-center justify-center mb-sm">
                        <img
                          src={recognition.image}
                          alt={recognition.alt}
                          className="max-h-24 w-full object-contain"
                          loading="lazy"
                          decoding="async"
                        />
                      </div>
                      <span className="text-xs font-bold uppercase tracking-[0.22em] text-on-surface-variant">
                        {recognition.title}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
